import { Dispatch } from "redux";
import { ActionType } from "../action-types";
import { Action } from "../actions";
import { SideBarMenu } from "../../types/SidebarMenu";

export const SwitchAlertOn = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ON,
      payload: true,
    });
  };
};

export const SwitchAlertOff = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.OFF,
      payload: false,
    });
  };
};

export const AddGlobalError = (error: { status: number; message: string }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_GLOBAL_ERROR,
      payload: error,
    });
  };
};

export const RemoveGlobalError = (index: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.REMOVE_GLOBAL_ERROR,
      payload: index,
    });
  };
};

export const ClearGlobalErrors = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.CLEAR_GLOBAL_ERROR });
  };
};

export const GetMenus = (items: SideBarMenu[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_MENU,
      payload: items,
    });
  };
};
